import React from 'react';
import PropTypes from "prop-types";
import { withStyles, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { themeTypeToBool } from '../../utils/helpers';
import t from "../../languages/pl";

const useStyles = theme => ({
    container: {
        marginBottom: 2
    },
    formControl: {
        width: 120,
        margin: theme.spacing(1)
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? theme.palette.common.black : theme.palette.common.white,
    }
});

const SelectFilter = props => {
    const { classes, label, value, onChange, options=[] } = props;

    const handleChange = (e) => {
        if(onChange)
            onChange(e.target.value);
    };

    return (
        <div className={classes.container}>
            <FormControl className={classes.formControl}>
                <InputLabel
                    shrink={true}
                    classes={{root: classes.label}}
                >
                    {label}
                </InputLabel>
                <Select
                    value={value}
                    onChange={handleChange}
                    classes={{select: classes.select}}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left"
                        },
                        getContentAnchorEl: null
                    }}
                >
                    <MenuItem value="">
                        <em>{t.pick}</em>
                    </MenuItem>
                    {options.map((group, idx) =>
                        <MenuItem
                            key={idx}
                            value={group}
                        >
                            {group.label ? group.label : group.name === 'Rozłączony+' ? 'Rozłączony > 24h' : group.name }
                        </MenuItem>)}
                </Select>
            </FormControl>
        </div>
    );
};

export default withStyles(useStyles)(SelectFilter);

SelectFilter.propTypes = {
    classes: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    label: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func
};
